import client from '@stores/apollo'
import gql from 'graphql-tag'
import { IPageInfo, INeighborhoodImportVersion } from '@api'
import { PageInfoFragment, NeighborhoodImportVersionFragment } from '@api/fragments'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  node: {
    createdAt: string
    importedBy: string
    versions: {
      pageInfo: IPageInfo
      edges: { node: INeighborhoodImportVersion }[]
    }
  }
}

interface INeighborhoodEmployeeDetails {
  details: INeighborhoodImportVersion[]
  pageInfo: IPageInfo
  createdAt: string
  importedBy: string
}

const mutateHandler = handleFetchResult<IPayload, INeighborhoodEmployeeDetails>({
  handler: ({
    node: {
      versions: { pageInfo, edges },
      createdAt,
      importedBy,
    },
  }) => ({
    details: edges.map(({ node }: { node: INeighborhoodImportVersion }) => node),
    pageInfo,
    createdAt,
    importedBy,
  }),
  name: 'Neighborhood',
})

export default function details(
  id: string,
  after: string | null,
  events: string[]
): Promise<INeighborhoodEmployeeDetails> {
  return client.gql.query({ query, variables: { id, after, events } }).then(mutateHandler)
}

const query = gql`
  query node($id: ID!, $after: String, $events: [EmployeesNeighborhoodsImportEvent]!) {
    node(id: $id) {
      ... on EmployeesNeighborhoodsImport {
        createdAt
        importedBy
        versions(first: 30, after: $after, events: $events) {
          pageInfo {
            ...PageInfoFragment
          }
          edges {
            node {
              ...NeighborhoodImportVersionFragment
            }
          }
        }
      }
    }
  }
  ${PageInfoFragment}
  ${NeighborhoodImportVersionFragment}
`
